// extracted by mini-css-extract-plugin
module.exports = {"intervalSwitchContainer":"SubscriptionBillingIntervalSwitch_intervalSwitchContainer__MXJqv"};